import { templates }          from "./templates";
import { CustomerConfig }     from "../../src/types";
import { renderTemplate }     from "./render";

const config: CustomerConfig = {
  name: {
    en: 'Card Generator',
    de: 'Karten Generator'
  },
  title: {
    en: 'Card Generator',
    de: 'Karten Generator'
  },
    favicon: require('./assets/favicon.png').default,
    logo: {
        path: require('./assets/app-logo-teltow-flaeming.png').default,
        smallPath: require('./assets/favicon.png').default,
        width: 175,
        height: 56,
        margin: 20
    },
    /*
    info: {
        en: 'defaultTranslation',
        de: 'defaultTranslation'
    },
     */
    templates,
    fonts: [
        {
            name: 'Poppins-Regular',
            src: `url(${ require('./assets/fonts/Poppins-Regular.ttf').default })`
        },
        {
            name: 'Poppins-SemiBold',
            src: `url(${ require('./assets/fonts/Poppins-SemiBold.ttf').default })`
        },
        {
            name: 'AlFresco',
            src: `url(${ require('./assets/fonts/AlFresco.ttf').default })`
        },
        {
            name: 'Parisienne-Regular',
            src: `url(${ require('./assets/fonts/Parisienne-Regular.ttf').default })`
        },
        {
            name: 'Roboto-Light',
            src: `url(${ require('./assets/fonts/Roboto-Light.ttf').default })`
        },
        {
            name: 'MeieScript-Regular',
            src: `url(${ require('./assets/fonts/MeieScript-Regular.ttf').default })`
        },
        {
            name: 'Cookie-Regular',
            src: `url(${ require('./assets/fonts/Cookie-Regular.ttf').default })`
        },
        {
            name: 'Tangerine-Bold',
            src: `url(${ require('./assets/fonts/Tangerine-Bold.ttf').default })`
        }
    ],
    theme: {
        palette: {
            common: { black: "#000", white: "#fff" },
            background: { paper: "#fff", default: "#fafafa" },
            primary: {
                light: "rgba(84, 89, 95, 1)",
                main: "#DDD",
                dark: "rgba(0, 0, 0, 1)",
                contrastText: "#555"
            },
            secondary: {
                light: "rgba(0, 143, 100, 1)",
                main: "#151515",
                dark: "#2c2c2c",
                contrastText: "#fff"
            },
            error: { light: "#e57373", main: "#f44336", dark: "#d32f2f", contrastText: "#fff" },
            text: {
                primary: "rgba(0, 0, 0, 0.87)",
                secondary: "rgba(0, 0, 0, 0.54)",
                disabled: "rgba(0, 0, 0, 0.38)",
                hint: "rgba(0, 0, 0, 0.38)"
            }
        }
    },
    translations: {
        de: {
            'preview.copy-image': 'Karte zur Veröffentlichung einreichen'
        },
        en: {
            'preview.copy-image': 'Submit card for publication'
        }
    },
    mailtoUrl: 'mailto:info@teltow-flaeming.de?subject=Karte+einreichen',
    renderTemplate
}

export default config;